export const ADD_TASK = 'ADD_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const COMPLETE_TASK = 'COMPLETE_TASK';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';